import { lazy, type FC } from 'react';
import { useParams } from 'react-router';
import { usePriceStepsChangeRequest } from 'src/apis/transport-auction/use-price-steps-change-request';
import { useTransportAuctionServiceRoot } from 'src/apis/transport-auction/use-transport-auction-service-root';
import { PageSpinner } from 'src/components/spinner-container';

const Page = lazy(() => import('./page'));

export const ManagePriceStepsChange: FC = () => {
  const { auctionId } = useParams<{ auctionId: string }>();

  const transportAuctionServiceRoot = useTransportAuctionServiceRoot();

  const priceStepsChangeRequest = usePriceStepsChangeRequest({
    root: transportAuctionServiceRoot,
    auctionId,
  });

  if (!priceStepsChangeRequest.response) return <PageSpinner />;

  return <Page priceStepsChangeRequest={priceStepsChangeRequest} />;
};
